<template>
  <div class="category">

    <div class="swiper" v-for="(item,index) in list" :key="index">
      <el-select v-model="item.type" clearable placeholder="请选择类型" @change="typeChange(index, idx)" style="width: 100px; margin-right:10px;">
        <!-- <el-option value="sc_pr" label="放映项目"></el-option> -->
        <el-option value="image" label="图片"></el-option>
        <el-option value="video" label="视频"></el-option>
      </el-select>



      <div style="width: 200px; display: inline;" v-if="item.type === 'image'">
        <img v-if="item.image" class="thumb cursor-pointer" :src="item.image" title="点击更换" @click="selectThumb(item)">
        <div v-else class="addimg" @click="selectThumb(item)">+</div>
      </div>

      <div style="width: 500px; display: inline;" v-else-if="item.type === 'video'">
        <el-input v-model="item.video" placeholder="视频链接"></el-input>
      </div>

      <el-button type="text" @click="deleteSwiper(index, idx)" size="mini" style="margin-left:10px;">删除</el-button>
      <el-button type="text" @click="addSwiper(index)" size="mini">添加</el-button>
    </div>

    <upload-img ref="upload" tips-width="750" tips-height="420"></upload-img>

    <el-button type="primary" @click="saveChange">保存更改</el-button>

  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
export default {
  components: {
    UploadImg
  },
  data () {
    return {
      list: [
        {
          type: 'image',
          image: '',
          video: '',
          link: ''
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      request({
        url: '/topic/swiper',
      }).then(res => {
        this.list = res.data.list
      })
    },
    deleteSwiper (index) {
      this.list.splice(index, 1)
    },
    addSwiper (index) {
      this.list.splice(index + 1, 0, {
        type: 'image',
        image: '',
        video: '',
        link: ''
      })
    },
    selectThumb (item) {
      let list = []
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          item.image = res[0]
        }
      }).catch()
    },
    saveChange () {
      request({
        method: 'put',
        url: '/topic/swiper',
        data: {
          list: this.list
        }
      }).then(res => {
        this.$message.success('保存成功!')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}

.swiper {
  display: flex;
  margin: 10px 0px;
}

.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}

.thumb {
  height: 50px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/topic/Swiper.vue